import React, { useState } from 'react';
import { RadioButton, styled, Text, TextAppearance, TextColor } from '@volkswagen-onehub/components-core';
import { Info } from 'src/icons-core-imports';
import { useDispatch } from 'react-redux';
import { useFormContext } from 'react-hook-form';
import { ctaEnviarRespuesta } from 'src/feature-app/InputsValues';

const LabelInfoWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

const InfoWrapper = styled.div`
  margin-left: 16px;
  cursor: pointer;
  svg {
    fill: #001e50;
  }
`;

export const ChecksEnvio = () => {
  const dispatch = useDispatch();
  const [firstCta, secondCta, thirdCta] = ctaEnviarRespuesta;
  const [firstOpen, setFirstOpen] = useState<boolean>(false);
  const [secondOpen, setSecondOpen] = useState<boolean>(false);

  const [checkedOne, setCheckedOne] = useState(false);
  const [checkedTwo, setCheckedTwo] = useState(false);
  const [checkedThree, setCheckedThree] = useState(false);

  const [value, setValue] = useState(null);
  const { register } = useFormContext();

  const handleOnClick = (e: any) => {
    dispatch({ type: 'UPDATE_FIELDS', payload: { enviarConcesion: e.currentTarget.value } });
  };

  return (
    <div style={{ paddingTop: '40px' }}>
      <div style={{ paddingBottom: '20px', paddingLeft: '12px' }}>
        <RadioButton
          value={firstCta.value}
          label={firstCta.label}
          name="enviarConcesion"
          onClick={(e) => {
            setValue(firstCta.value);
            setCheckedOne(true);
            setCheckedTwo(false);
            setCheckedThree(false);
            handleOnClick(e);
          }}
          checked={checkedOne}
        />
      </div>
      <div style={{ paddingBottom: '20px', paddingLeft: '12px' }}>
        <LabelInfoWrapper className="label-info-wrapper">
          <RadioButton
            value={secondCta.value}
            label={secondCta.label}
            name="enviarConcesion"
            onClick={(e) => {
              setValue(secondCta.value);
              setCheckedOne(false);
              setCheckedTwo(true);
              setCheckedThree(false);
              handleOnClick(e);
            }}
            checked={checkedTwo}
          />
          <InfoWrapper
            onClick={(e) => {
              e.preventDefault();
              setFirstOpen(!firstOpen);
            }}
          >
            <Info />
          </InfoWrapper>
        </LabelInfoWrapper>
        {firstOpen ? (
          <div style={{ paddingTop: '8px', paddingLeft: '36px' }}>
            <Text appearance={TextAppearance.copy0150} color={TextColor.secondary}>
              {secondCta.extraInfo}
            </Text>
          </div>
        ) : null}
      </div>
      <div style={{ paddingLeft: '12px' }}>
        <LabelInfoWrapper className="label-info-wrapper">
          <RadioButton
            value={thirdCta.value}
            label={thirdCta.label}
            name="enviarConcesion"
            onClick={(e) => {
              setValue(thirdCta.value);
              setCheckedOne(false);
              setCheckedTwo(false);
              setCheckedThree(true);
              handleOnClick(e);
            }}
            checked={checkedThree}
          />
          <InfoWrapper
            onClick={(e) => {
              e.preventDefault();
              setSecondOpen(!secondOpen);
            }}
          >
            <Info />
          </InfoWrapper>
        </LabelInfoWrapper>
        {secondOpen ? (
          <div style={{ paddingTop: '8px', paddingLeft: '36px' }}>
            <Text appearance={TextAppearance.copy0150} color={TextColor.secondary}>
              {thirdCta.extraInfo}
            </Text>
          </div>
        ) : null}
      </div>
      <input
        type="hidden"
        name="enviarConcesion"
        value={value}
        ref={register({
          required: {
            value: true,
            message: 'Requerido',
          },
        })}
      />
    </div>
  );
};
